// extracted by mini-css-extract-plugin
module.exports = {"couponWrapper":"styles-module__couponWrapper___25A1X"};